module.exports = __webpack_public_path__ + "static/media/taro2.25820af9.jpg";